import type {
  CollectionActions,
  CollectionStateSlice,
  Reference,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { transformAdminProject } from './admin-projects.transformers';
import type { AdminProjectsCollection } from './admin-projects.types';

export function adminProjectsReducer(
  state: CollectionStateSlice<AdminProjectsCollection> = {},
  action: CollectionActions<AdminProjectsCollection>,
): CollectionStateSlice<AdminProjectsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'adminProjects') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<AdminProjectsCollection>(
          state,
          transformIntoDocuments(
            result.projects,
            transformAdminProject,
            result.selected_bids,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    case 'WS_MESSAGE': {
      const ref: Reference<AdminProjectsCollection> = {
        path: {
          collection: 'adminProjects',
          authUid: action.payload.toUserId,
        },
      };
      if (action.payload.parent_type === 'notifications') {
        switch (action.payload.type) {
          case 'projectBlasted': {
            const { projectId } = action.payload.data;
            return updateWebsocketDocuments<AdminProjectsCollection>(
              state,
              [projectId],
              project => ({
                ...project,
                isBlasted: true,
              }),
              ref,
            );
          }
          default:
            return state;
        }
      }
      return state;
    }
    default:
      return state;
  }
}
